interface InvoiceLayout {
  src: string;
  title: string;
  alt: string;
}

const INVOICE_LAYOUTS: InvoiceLayout[] = [
  {
    src: 'https://storage.helloreaddy.io/project_files/d29f47c9-44c4-419b-bc6f-99193685fe87/fd43b0e2-002e-4d29-8788-b9d0b0226b1e_compressed_carpenter_invoice.webp',
    title: 'Trade & Construction',
    alt: 'Carpenter invoice layout with woodwork background',
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/d29f47c9-44c4-419b-bc6f-99193685fe87/b13f3e43-579c-4a21-876f-86d5ab87d3e8_compressed_nursery_invoice.webp',
    title: 'Nursery & Garden',
    alt: 'Nursery invoice layout with floral garden background',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=A%20clean%20professional%20invoice%20document%20layout%20mockup%20shown%20at%20a%20gentle%20angle%20on%20a%20soft%20warm%20off-white%20studio%20background%2C%20minimalist%20typography%20with%20a%20company%20logo%20in%20the%20header%2C%20a%20neat%20line%20items%20table%2C%20subtotal%20and%20grand%20total%20section%2C%20subtle%20teal%20accent%20color%20for%20highlights%20and%20the%20total%20row%2C%20modern%20flat%20vector%20style%2C%20crisp%20details%2C%20soft%20diffused%20shadow%2C%20elegant%20product%20presentation%2C%20balanced%20composition&width=600&height=800&seq=custom-invoice-01&orientation=portrait',
    title: 'Clean & Minimal',
    alt: 'Clean minimal invoice layout with teal accent',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=A%20clean%20professional%20invoice%20document%20layout%20mockup%20shown%20at%20a%20gentle%20angle%20on%20a%20soft%20warm%20off-white%20studio%20background%2C%20modern%20typography%20with%20a%20bold%20company%20name%20header%2C%20an%20organized%20line%20items%20table%20with%20quantity%20and%20price%20columns%2C%20a%20clear%20subtotal%20and%20total%20block%2C%20subtle%20warm%20orange%20accent%20color%20for%20headings%20and%20the%20total%20amount%2C%20contemporary%20flat%20vector%20style%2C%20crisp%20details%2C%20soft%20diffused%20shadow%2C%20elegant%20product%20presentation%2C%20balanced%20composition&width=600&height=800&seq=custom-invoice-02&orientation=portrait',
    title: 'Bold & Modern',
    alt: 'Bold modern invoice layout with orange accent',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=A%20clean%20professional%20invoice%20document%20layout%20mockup%20shown%20at%20a%20gentle%20angle%20on%20a%20soft%20warm%20off-white%20studio%20background%2C%20refined%20typography%20with%20a%20company%20monogram%20header%2C%20a%20structured%20line%20items%20table%2C%20tax%20and%20total%20summary%20section%2C%20subtle%20emerald%20green%20accent%20color%20for%20borders%20and%20the%20total%20row%2C%20modern%20flat%20vector%20style%2C%20crisp%20details%2C%20soft%20diffused%20shadow%2C%20elegant%20product%20presentation%2C%20balanced%20composition&width=600&height=800&seq=custom-invoice-03&orientation=portrait',
    title: 'Refined & Classic',
    alt: 'Refined classic invoice layout with emerald accent',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=A%20clean%20professional%20invoice%20document%20layout%20mockup%20shown%20at%20a%20gentle%20angle%20on%20a%20soft%20warm%20off-white%20studio%20background%2C%20elegant%20typography%20with%20a%20company%20wordmark%20header%2C%20a%20detailed%20line%20items%20table%20with%20descriptions%2C%20a%20subtotal%20tax%20and%20total%20section%2C%20subtle%20deep%20navy%20accent%20color%20for%20the%20header%20band%20and%20total%20row%2C%20modern%20flat%20vector%20style%2C%20crisp%20details%2C%20soft%20diffused%20shadow%2C%20elegant%20product%20presentation%2C%20balanced%20composition&width=600&height=800&seq=custom-invoice-04&orientation=portrait',
    title: 'Corporate & Trusted',
    alt: 'Corporate invoice layout with navy accent',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=A%20clean%20professional%20invoice%20document%20layout%20mockup%20shown%20at%20a%20gentle%20angle%20on%20a%20soft%20warm%20off-white%20studio%20background%2C%20ultra%20minimal%20monochrome%20typography%20with%20a%20small%20company%20logo%2C%20a%20spacious%20line%20items%20table%2C%20a%20simple%20subtotal%20and%20total%20section%2C%20black%20text%20with%20subtle%20gray%20dividers%20and%20no%20bright%20accent%20color%2C%20modern%20flat%20vector%20style%2C%20crisp%20details%2C%20soft%20diffused%20shadow%2C%20elegant%20product%20presentation%2C%20balanced%20composition&width=600&height=800&seq=custom-invoice-05&orientation=portrait',
    title: 'Monochrome',
    alt: 'Monochrome minimal invoice layout',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=A%20clean%20professional%20invoice%20document%20layout%20mockup%20shown%20at%20a%20gentle%20angle%20on%20a%20soft%20warm%20off-white%20studio%20background%2C%20friendly%20rounded%20typography%20with%20a%20company%20logo%20badge%20header%2C%20an%20organized%20line%20items%20table%2C%20a%20subtotal%20and%20total%20summary%20card%2C%20subtle%20coral%20accent%20color%20for%20the%20total%20card%20and%20highlights%2C%20modern%20flat%20vector%20style%2C%20crisp%20details%2C%20soft%20diffused%20shadow%2C%20elegant%20product%20presentation%2C%20balanced%20composition&width=600&height=800&seq=custom-invoice-06&orientation=portrait',
    title: 'Friendly & Approachable',
    alt: 'Friendly invoice layout with coral accent',
  },
];

export default function InvoiceGalleryMarquee() {
  const items = [...INVOICE_LAYOUTS, ...INVOICE_LAYOUTS];

  return (
    <div
      className="relative overflow-hidden select-none"
      onContextMenu={(e) => e.preventDefault()}
      onDragStart={(e) => e.preventDefault()}
    >
      <div className="flex w-max gap-6 animate-marquee">
        {items.map((item, index) => (
          <div key={index} className="flex flex-col gap-3 shrink-0">
            <div className="relative w-[250px] h-[333px] md:w-[280px] md:h-[373px] rounded-xl overflow-hidden bg-gray-100 border border-gray-200">
              <img
                src={item.src}
                alt={item.alt}
                title={item.title}
                draggable={false}
                className="w-full h-full object-cover object-top pointer-events-none"
                style={{ WebkitUserDrag: 'none' as const }}
              />
              {/* Transparent shield to block right-click / save-as on the image */}
              <div
                className="absolute inset-0"
                onContextMenu={(e) => e.preventDefault()}
                aria-hidden="true"
              />
            </div>
            <p className="text-sm text-gray-600 font-medium text-center whitespace-nowrap">
              {item.title}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}